import React from 'react';
import {paths} from '../../common/dictionaries/urls';
import CustomerTracking from '.';

export const customerTrackingRoutes = [
  {'component': <CustomerTracking />, 'path': paths.CustomerTracking},
];
